<template>
  <div class="header-wrapper" :class="{ 'events-page': $route.path.startsWith('/event') || $route.path.startsWith('/confirm') }">
    <button v-if="canScrollLeft" class="scroll-arrow scroll-left" @click="scrollLeft" aria-label="Scroll left">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    </button>

    <div class="header row" ref="headerEl" v-if="getAdminProps">
      <div class="logo">
        <img :src="getAdminProps.companyLogo.path" alt="logo" v-if="getAdminProps">
        <img src="@/assets/beel_logo.png" alt="logo" v-if="!getAdminProps">
      </div>
      <div class="row">
        <header-item v-for="location in locationList" :key="location.id" :name="location.name"
          :isActive="selectedLocation.id === location.id && !$route.path.startsWith('/event') && !$route.path.startsWith('/confirm')"
          @click="changeLocation(location)">
        </header-item>
      </div>
      <div v-if="getAdminProps.isEventsEnabled" class="row">
        <header-item name="События" :isActive="this.$route.path.startsWith('/event')" @click="goToEvents()">
        </header-item>
      </div>
    </div>

    <button v-if="canScrollRight" class="scroll-arrow scroll-right" @click="scrollRight" aria-label="Scroll right">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    </button>
  </div>
</template>

<script>
  import HeaderItem from './HeaderItem.vue'
  import apiClient from "../../apiClient";
  import serverConfig from "../../serverConfig";
  import { EventBus } from "../../eventBus";
  import { getServerUrl } from "../../globalConfig";

  export default {
    components: { HeaderItem },
    name: 'Head',
    computed: {
      selectedLocation() {
        return this.$store.state.selectedLocation
      },
      locationList() {
        return this.$store.state.locationList
      },
      getAdminProps() {
        return this.$store.state.adminProperties
      },
      isEventPage(){
        return this.$store.state.adminProperties.isEventsEnabled
      }
    },
    data() {
      return {
        locations: [],
        canScrollLeft: false,
        canScrollRight: false
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.checkScrollability();
        window.addEventListener('resize', this.checkScrollability);

        if (this.$refs.headerEl) {
          this.$refs.headerEl.addEventListener('scroll', this.onScroll);
        }
      });
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.checkScrollability);

      if (this.$refs.headerEl) {
        this.$refs.headerEl.removeEventListener('scroll', this.onScroll);
      }
    },
    methods: {
      changeLocation(location) {
        this.$store.dispatch('selectLocation', location).then(response => {
          EventBus.$emit('changeLocation', location)
        });

        if (this.$route.path.startsWith('/event') || this.$route.path.startsWith('/confirm')) {
          this.$router.push('/');
        }
      },
      goToEvents() {
        this.$router.push('/event');
      },
      onScroll() {
        // Use requestAnimationFrame to avoid too many updates
        window.requestAnimationFrame(() => {
          this.checkScrollability();
        });
      },
      checkScrollability() {
        if (this.$refs.headerEl) {
          const header = this.$refs.headerEl;
          this.canScrollLeft = header.scrollLeft > 5;
          this.canScrollRight = header.scrollLeft < (header.scrollWidth - header.clientWidth - 5);
        }
      },
      scrollLeft() {
        if (this.$refs.headerEl) {
          const header = this.$refs.headerEl;
          const scrollAmount = 300;

          // Use direct DOM manipulation for more reliable scrolling
          const targetScrollLeft = Math.max(0, header.scrollLeft - scrollAmount);

          // Animate scroll with requestAnimationFrame for smoother scrolling
          this.animateScroll(header, targetScrollLeft);
        }
      },
      scrollRight() {
        if (this.$refs.headerEl) {
          const header = this.$refs.headerEl;
          const scrollAmount = 300;

          // Use direct DOM manipulation for more reliable scrolling
          const targetScrollLeft = header.scrollLeft + scrollAmount;

          // Animate scroll with requestAnimationFrame for smoother scrolling
          this.animateScroll(header, targetScrollLeft);
        }
      },
      animateScroll(element, targetScrollLeft) {
        const startScrollLeft = element.scrollLeft;
        const distance = targetScrollLeft - startScrollLeft;
        const duration = 300; // ms
        let startTime = null;

        const step = (timestamp) => {
          if (!startTime) startTime = timestamp;
          const elapsed = timestamp - startTime;
          const progress = Math.min(elapsed / duration, 1);

          // Easing function for smoother animation
          const easeInOutCubic = progress < 0.5
            ? 4 * progress * progress * progress
            : 1 - Math.pow(-2 * progress + 2, 3) / 2;

          element.scrollLeft = startScrollLeft + distance * easeInOutCubic;

          if (elapsed < duration) {
            window.requestAnimationFrame(step);
          } else {
            // Ensure we end exactly at the target
            element.scrollLeft = targetScrollLeft;
            this.checkScrollability();
          }
        };

        window.requestAnimationFrame(step);
      }
    }
  }
</script>

<style>
.header-wrapper {
  position: relative;
  max-width: 80%;
}

.header-wrapper.events-page {
  max-width: 100%;
}

.header {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 25px 100px;
  gap: 12px;
  width: 100%;
  box-sizing: border-box;
  border-bottom: 1px solid #F1F1F1;
  box-shadow: 0 2px 4px 0 rgba(16, 24, 40, 0.05);
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;
  /* IE and Edge */
}

.header::-webkit-scrollbar {
  display: none;
  /* Chrome, Safari, Opera */
}

.logo {
  padding-right: 14px;
  flex-shrink: 0;
}

.logo img {
  width: 120px;
  height: 30px;
  object-fit: cover;
}

.row {
  display: flex;
  flex-direction: row;
  text-decoration: none;
  gap: 12px;
  align-items: center;
  flex-shrink: 0;
}

.scroll-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: white;
  border: 1px solid #EAECF0;
  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #667085;
  z-index: 10;
  transition: all 0.2s ease;
}

.scroll-arrow:hover {
  background-color: #F9FAFB;
  color: #101828;
}

.scroll-left {
  left: 5px;
}

.scroll-right {
  right: 0px;
}

/* @media (max-width: 1620px) {
  .header-wrapper:not(.events-page) {
    max-width: 77%;
  }
}

@media (max-width: 1500px) {
  .header-wrapper:not(.events-page) {
    max-width: 75%;
  }
}

@media (max-height: 1060px) {
  .header-wrapper:not(.events-page) {
    max-width: 62%;
  }
} */

@media (max-width: 1050px) {
  .header-wrapper {
    max-width: 100%;
    width: 100%;
  }

  .header {
    padding: 15px 20px;
    width: 100%;
  }

  .scroll-arrow {
    width: 32px;
    height: 32px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/client/Head.vue